<template>
  <div class="check-box">
    <el-checkbox

      v-model="checkAll"
      :disabled="dis"
      @change="handleCheckAllChange"
      class="box-head"
      >{{ msg.menuName }}</el-checkbox
    >
    <el-checkbox-group
      class="box-group"
      v-model="checkedCities"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        class="group-item"
        :disabled="dis"
        v-for="city in cities"
        :label="city.menuId"
        :key="city.menuId"
        >{{ city.menuName }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>

<script>

export default {
  name: "checkBox",
  props:["msg","checkindex","dis"],
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      allcitys:[],

    };
  },
  methods: {
    checkfir(){

      this.checkAll=this.msg.authorization
      this.checkedCities=[]
      if( this.checkAll){
        this.checkedCities.push(this.msg.menuId)
      }
      for(let i=0;i<this.msg.children.length;i++){
        this.allcitys.push(this.msg.children[i].menuId)
        if(this.msg.children[i].authorization){
          this.checkedCities.push(this.msg.children[i].menuId)
        }
      }
    },
    handleCheckAllChange(val) {

      if(val){
        this.checkedCities = this.allcitys
          this.checkedCities.push(this.msg.menuId)
      }else{
      for(let i=0;i<this.checkedCities.length;i++){
        if(this.msg.menuId==this.checkedCities[i]){
          this.checkedCities.splice(i,1)
        }
}
      }
      console.log(this.checkedCities)
      // this.checkedCities = val ? this.allcitys : [];
      // this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {

      let checkedCount = value.length;
      // this.checkAll = checkedCount === this.cities.length;
      // this.isIndeterminate =
      //   checkedCount > 0 && checkedCount < this.cities.length;
    },
  },
  mounted() {

    this.cities=this.msg.children

    this.checkindex=this.checkindex

  },
  watch:{
    msg(){
      this.checkfir()
    },
    checkedCities(){
      console.log(this.checkedCities)
      this.$emit('checkdata',[this.checkindex,this.checkedCities]);
    }

  }
};
</script>

<style lang="less" scoped>
.check-box {
  width: 170px;
  height: 340px;
  border-radius: 3px;
  border: 1px solid #dcdfe6;
}
</style>
<style lang="less">
.box-head {
  width: 100%;
  border-bottom: 1px solid #dcdfe6;
  padding: 9px 16px;
  .el-checkbox__label {
    font-size: 14px !important;
    color: #909399;
  }
}
.box-group {
  padding: 9px 16px;
  .group-item {
    width: 100%;
    margin:6px 0;
    .el-checkbox__label {
      font-size: 14px !important;
      color: #606266;
    }
  }
}
</style>
